<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'ResultNotFound',
    computed: {
      ...mapState('auth', { activeUser: 'user' }),
    },
    created() {
      this.getRoutesForUser(this.activeUser)
    },
    destroyed() {
      this.clearError()
    },
    methods: {
      ...mapActions('app', ['clearError']),
      ...mapActions('auth', ['getRoutes']),
      getRoutesForUser(user) {
        // update routes
        user && this.getRoutes()
      },
      routeBack() {
        this.$router.go(-1)
      },
    },
  }
</script>
